const NAME = 'REFINER';
const CNameMapping = {
  [NAME]: NAME,
  Refiner: NAME,
  refiner: NAME,
};

export { NAME, CNameMapping };
